export const OWNER_VOICE_SESSION_KEY_PREFIX = "anokina.voice.ownerProof.activeSession";

export function voiceSessionStorageKey(ownerId) {
  return `${OWNER_VOICE_SESSION_KEY_PREFIX}:${ownerId}`;
}

export function loadVoiceSessionId(ownerId, storage = window.localStorage) {
  try { return storage.getItem(voiceSessionStorageKey(ownerId)); } catch { return null; }
}

export function saveVoiceSessionId(ownerId, sessionId, storage = window.localStorage) {
  try { storage.setItem(voiceSessionStorageKey(ownerId), sessionId); } catch { /* optional pointer cache */ }
}

export function clearVoiceSessionId(ownerId, storage = window.localStorage) {
  try { storage.removeItem(voiceSessionStorageKey(ownerId)); } catch { /* optional pointer cache */ }
}
